import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

// 商城订单接口
export interface MallOrder {
  id: number;
  order_no: string;
  status: string;
  status_text: string;
  is_presale: boolean;
  payment_mode: string;
  payment_mode_text: string;
  quantity: number;
  unit_price: string;
  original_amount: string;
  discount_amount: string;
  total_amount: string;
  deposit_amount: string;
  paid_amount: string;
  coupon_info: {
    id: number;
    name: string;
    coupon_type: string;
    discount_text: string;
  } | null;
  product_snapshot: {
    id: number;
    name: string;
    image: string;
    price: string;
  };
  address_snapshot: {
    name: string;
    mobile: string;
    area: string;
    detail: string;
  };
  user: {
    id: number;
    nickname: string;
    mobile: string;
  };
  payments: Array<{
    id: number;
    payment_type: string;
    amount: string;
    balance_used: string;
    alipay_amount: string;
    status: string;
    paid_at: string;
  }>;
  shipment: {
    id: number;
    shipping_company: string;
    tracking_no: string;
    shipped_at: string;
  } | null;
  created_at: string;
  paid_at: string | null;
  arrival_notified_at: string | null;
  final_paid_at: string | null;
  shipped_at: string | null;
  completed_at: string | null;
  cancelled_at: string | null;
  cancel_reason: string | null;
  refunded_at: string | null;
}

@Module
export default class MallOrderModule extends VuexModule {
  mall_orders = [] as Array<MallOrder>;
  mall_order_count = 0;
  mall_order = {} as MallOrder;
  download_mall_orders = {} as any;

  get currentMallOrder(): MallOrder {
    return this.mall_order;
  }

  get currentMallOrders(): Array<MallOrder> {
    return this.mall_orders;
  }

  get currentMallOrderCount() {
    return this.mall_order_count;
  }

  get currentDownloadMallOrders() {
    return this.download_mall_orders;
  }

  @Mutation
  [Mutations.SET_MALL_ORDER](mall_order) {
    this.mall_order = mall_order;
  }

  @Mutation
  [Mutations.SET_MALL_ORDERS](mall_orders) {
    this.mall_orders = mall_orders;
  }

  @Mutation
  [Mutations.SET_MALL_ORDER_COUNT](mall_order_count) {
    this.mall_order_count = mall_order_count;
  }

  @Mutation
  [Mutations.SET_DOWNLOAD_MALL_ORDERS](download_mall_orders) {
    this.download_mall_orders = download_mall_orders;
  }

  @Action
  [Actions.GET_MALL_ORDERS](params) {
    ApiService.setHeader();

    let queryString = "?";

    if (params) {
      Object.keys(params).forEach((i) => {
        if (params[i] !== undefined && params[i] !== null && params[i] !== '') {
          queryString += "&" + i + "=" + params[i];
        }
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/orders", queryString)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_MALL_ORDERS, data["orders"]);
          this.context.commit(Mutations.SET_MALL_ORDER_COUNT, data["total_result"]);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.GET_MALL_ORDER](id) {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.get(`admin/orders/${id}`)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_MALL_ORDER, data["order"]);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.UPDATE_MALL_ORDER](credentials) {
    ApiService.setHeader();

    const params = {
      order: {
        ...credentials.values,
      },
    };

    return new Promise<void>((resolve, reject) => {
      ApiService.put(`admin/orders/${credentials.id}`, params)
        .then(({ data }) => {
          if (data && data["order"]) {
            this.context.commit(Mutations.SET_MALL_ORDER, data["order"]);
          }
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.SHIP_MALL_ORDER](credentials) {
    ApiService.setHeader();

    const params = {
      shipping_company: credentials.shipping_company,
      tracking_no: credentials.tracking_no,
    };

    return new Promise<void>((resolve, reject) => {
      ApiService.post(`admin/orders/${credentials.id}/ship`, params)
        .then(({ data }) => {
          if (data && data["order"]) {
            this.context.commit(Mutations.SET_MALL_ORDER, data["order"]);
          }
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.DOWNLOAD_MALL_ORDERS](params) {
    ApiService.setHeader();

    let queryString = "?";

    if (params) {
      Object.keys(params).forEach((i) => {
        if (params[i] !== undefined && params[i] !== null && params[i] !== '') {
          queryString += "&" + i + "=" + params[i];
        }
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/orders/export", queryString, { responseType: 'blob' })
        .then(({ data }) => {
          this.context.commit(Mutations.SET_DOWNLOAD_MALL_ORDERS, data);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }
}
